import Vue from "vue";
import VueI18n from 'vue-i18n'
import zn from "./zn"
import en from "./en"
Vue.use(VueI18n)
 
const i18n = new VueI18n({
  locale: "zn",
  messages: {
    "zn":zn,
    "en":en
  }
})
 
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js